import { h } from 'preact';
import React, { Component } from 'react';
import Toggle from '../Components/Toggle';
import { makeText, formatDescription } from '../../../util';
export default class PurposeContent extends Component {
  state = {
    vendorsAll: false
  }
  toggleVendors = () => {
    const vendorsAll = !this.state.vendorsAll;
    this.setState({ vendorsAll }, this.props.force);
  }
  render() {
    const { feature, settings, language, force, dev, isCustom, accordionOpen } = this.props;
    const { vendorsAll } = this.state;

    const viewAllText = makeText(Boolean(dev), settings, 'viewAllText', language);
    const viewLessText = makeText(Boolean(dev), settings, 'viewLessText', language);
    const purposeVendorTitle = makeText(Boolean(dev), settings, 'purposeVendorTitle', language);

    return (
      <div className="purpose-content">
        <p style="margin-bottom:15px;">
          {isCustom ? feature.description : formatDescription(feature.description)}
        </p>
        <div style={{ position: 'relative' }}>
          <div className="policies">
            <div className="pv-title">{purposeVendorTitle}</div>
            {feature.vendors.slice(0, vendorsAll ? feature.vendors.length : 3).map((v) => (
              <Toggle
                vendor={v}
                key={v.vendorId}
                language={language}
                settings={settings}
                force={force}
                isSpecialPurposeOrFeature
              />
            ))}
            {feature.vendors.length > 3 && (
              <div
                tabIndex={accordionOpen ? 0 : -1}
                className="view-all"
                onClick={this.toggleVendors}
                onKeyDown={e => e.keyCode == 13 && this.toggleVendors()}
              >
                {vendorsAll ? viewLessText : viewAllText}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}